/* eslint-disable no-unused-vars */

import React, {Component} from "react";
import {TextField, withStyles} from "@material-ui/core";
import classNames from 'classnames';

const styles = theme => ({
    input: {
        width: '100%',
    },
    wrapper:{
        paddingLeft:'8px',
        paddingRight:'8px'
    }
});

class TextInput extends Component {
    state = {
        active:     this.props.active || 1,
        cfi: ''
    }

    onChange = (event) => {

    }

    genCFI = () => {
        const { classes, value, width, onChange, fieldLabel, fieldName, fieldValue, errorFields, categoryValue, groupValue, lvl1Value,lvl2Value,lvl3Value,lvl4Value} = this.props;

        let CFI = '';
        if(typeof categoryValue !== "undefined" && categoryValue !== '' && categoryValue !== null){
            CFI = CFI + categoryValue;
            if(typeof groupValue !== "undefined" && groupValue !== '' && groupValue !== null){
                CFI = CFI + groupValue;
                if(typeof lvl1Value !== "undefined" && lvl1Value !== '' && lvl1Value !== null){
                    CFI = CFI + lvl1Value;
                    if(typeof lvl2Value !== "undefined" && lvl2Value !== '' && lvl2Value !== null){
                        CFI = CFI + lvl2Value;
                        if(typeof lvl3Value !== "undefined" && lvl3Value !== '' && lvl3Value !== null){
                            CFI = CFI + lvl3Value;
                            if(typeof lvl4Value !== "undefined" && lvl4Value !== '' && lvl4Value !== null){
                                CFI = CFI + lvl4Value;
                                console.log(CFI);
                            }
                        }
                    }
                }
            }
        }

        this.setState({
            cfi: CFI
        })
    }

        componentDidUpdate(prevProps, prevState, prevContext) {
            if(this.props.categoryValue !== prevProps.categoryValue
                || this.props.groupValue !== prevProps.groupValue
                || this.props.lvl1Value !== prevProps.lvl1Value
                || this.props.lvl2Value !== prevProps.lvl2Value
                || this.props.lvl3Value !== prevProps.lvl3Value
                || this.props.lvl4Value !== prevProps.lvl4Value
            ){
                this.genCFI();
            }
    }

    componentDidMount() {
        this.genCFI();
    }

    render() {
        const { classes, width, fieldLabel, fieldName} = this.props;

        return (
            <React.Fragment>
                <div className={classNames(classes.wrapper,width)}>

                    <TextField
                        id="standard-basic"
                        label={fieldLabel}
                        name={fieldName}
                        className={classes.input}
                        value={this.state.cfi}
                        onChange={this.props.onChange}
                        required={this.props.required}
                        disabled={true}
                    />
                </div>
            </React.Fragment>
        );
    }
}

export default withStyles(styles, { withTheme: true })(TextInput);


// WEBPACK FOOTER //
// ./src/yeffect/formBuilder/components/cfiValue.js